import store from '../../../vue/store'
import { cloneDeep, filter, flatMap, forEach, keys, map, pickBy, uniq, values, first, isEmpty } from 'lodash'

export default {
  props: {
    similarGroup: {
      type: Object
    },
    defaultValue: {
      type: String
    },
    similarProductGroupCombos: {
      type: Object
    },
    currentSimilarProductGroupCombo: {
      type: Array
    },
    forceDisplayAllValues: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: this.defaultValue
    }
  },
  computed: {
    // Group ids that has similarGroupDisplayPosition 2(FILTER) and 3(NONE)
    getExcludedSimilarProductGroupIds () {
      return this.$store.getters.allSimilars
        .filter(similar => similar.similarGroupDisplayPosition === 2 || similar.similarGroupDisplayPosition === 3)
        .map(similar => similar.similarGroupId)
    },
    getSimilarEntriesOfThisGroupFromSimilarGroupData () {
      const similarEntries = this.similarGroup.similars

      const similarEntriesMergedForStock = similarEntries.map(itm => ({
        ...this.getSimilarEntriesOfThisGroup.find((item) => {
          return item.similarId === itm.similarId && item
        }),
        ...itm
      }))

      return filter(similarEntriesMergedForStock, (similar) => {
        return this.getSimilarEntriesIdsOfThisGroup.includes(similar.similarId)
      }).sort((a, b) => parseInt(a.similarOrder) - parseInt(b.similarOrder))
    },
    getSimilarEntriesIdsOfThisGroup () {
      const ids = []
      const availableSimilarEntries = this.getSimilarEntriesOfThisGroup
      forEach(availableSimilarEntries, (similar) => {
        if (similar.similarGroupId === this.similarGroup.similarGroupId) {
          ids.push(similar.similarId)
        }
      })
      return ids
    },
    getSimilarEntriesOfThisGroup () {
      return filter(
        uniq(flatMap(values(this.getMatchingSimilarProductGroupCombos(this.getAllOtherSimilarGroups, this.forceDisplayAllValues)))),
        (groupCombo) => groupCombo.similarGroupId === this.similarGroup.similarGroupId
      )
    },
    getAllOtherSimilarGroups () {
      return filter(
        this.currentSimilarProductGroupCombo,
        (combo) => this.getAllOtherSimilarGroupIds.includes(combo.similarGroupId)
      )
    },
    getAllOtherSimilarGroupIds () {
      return filter(
        this.getAllSimilarGroupIds,
        (similarGroupId) => similarGroupId !== this.similarGroup.similarGroupId
      )
    },
    getAllSimilarGroupIds () {
      return uniq(map(this.getAllSimilarCombosFlat, (similarCombo) => similarCombo.similarGroupId))
    },
    getAllSimilarCombosFlat () {
      return uniq(flatMap(values(this.similarProductGroupCombos)))
    },
    getSelectedText () {
      if (this.defaultValue) {
        return this.defaultValue
      }
      if (!this.selected) {
        return ''
      }
      const selected = this.similarGroup.similars.find(item => item.similarId === this.selected)
      if (!selected) {
        return ''
      }
      return selected.similarName
    }
  },
  methods: {
    getMatchingSimilarProductGroupCombos (otherSimilarGroups, skipEqualCheck = false) {
      return pickBy(
        this.similarProductGroupCombos,
        (similarGroupCombo) => {
          return skipEqualCheck || this.areCombosEqual(otherSimilarGroups, similarGroupCombo)
        }
      )
    },
    areCombosEqual (comboList, otherComboList) {
      let matchCount = 0
      const comboListIgnoredLength = comboList
        .filter(combo => this.getExcludedSimilarProductGroupIds.includes(combo.similarGroupId))
        .length
      for (const otherCombo of otherComboList) {
        for (const combo of comboList) {
          if (
            this.getExcludedSimilarProductGroupIds.includes(otherCombo.similarGroupId) &&
            this.getExcludedSimilarProductGroupIds.includes(combo.similarGroupId)
          ) {
            continue
          }
          if (otherCombo.similarId === combo.similarId && otherCombo.similarGroupId === combo.similarGroupId) {
            matchCount += 1
          }
        }
      }
      return (matchCount === (comboList.length - comboListIgnoredLength))
    },
    getMatchingProductsBySimilarValueId (similarValueId, otherSimilarGroups = []) {
      const similarGroupId = this.similarGroup.similarGroupId
      const otherSimilarGroupsFilter = cloneDeep(otherSimilarGroups)
      const relatedSimilarData = store.getters.getRelatedSimilarData
      otherSimilarGroupsFilter.push({
        similarGroupId,
        similarId: similarValueId
      })
      const matchingProductIds = keys(this.getMatchingSimilarProductGroupCombos(otherSimilarGroupsFilter))
      return filter(relatedSimilarData, (similar) => {
        return matchingProductIds.includes(similar.product_id)
      })
    },
    navigateToProduct (similarValueId) {
      const categoryData = store.getters.getProductCategoryData
      let matchingProducts = this.getMatchingProductsBySimilarValueId(similarValueId, this.getAllOtherSimilarGroups)
      if (matchingProducts.length === 0) {
        matchingProducts = this.getMatchingProductsBySimilarValueId(similarValueId)
      }

      if (isEmpty(categoryData)) {
        this.navigateToVendorProduct(matchingProducts)
        return
      }

      this.navigateToCategoryProduct(matchingProducts, categoryData)
    },
    navigateToCategoryProduct (matchingProducts, categoryData) {
      if (matchingProducts.length === 0) {
        return
      }
      const urlDataLang = this.$store.getters.urlData.lang
      const urlSuffix = this.$store.getters.config.url.suffix
      const productSlug = first(matchingProducts).slug
      const categoryUrl = `/${urlDataLang}${categoryData.slug}/${productSlug}${urlSuffix}`
      window.location.assign(categoryUrl)
    },
    navigateToVendorProduct (matchingProducts) {
      if (matchingProducts.length === 0) {
        return
      }
      const vendorUrl = first(matchingProducts).productUrl
      window.location.replace(vendorUrl)
    }
  }
}
